  <router-outlet></router-outlet>


